const buildUrls = ({
  vision,
  pli,
  portal,
  sal,
  plugin,
}: {
  vision: string;
  pli: string;
  portal: string;
  sal: string;
  plugin: string;
}) => {
  let appsHomeUrl = "/";
  try {
    const salUrl = new URL(sal);
    salUrl.pathname = "/";
    salUrl.search = "";
    salUrl.hash = "";
    appsHomeUrl = salUrl.toString();
  } catch {
    appsHomeUrl = "/";
  }

  return {
    VISION_URL: vision,
    PLI_URL: pli,
    PORTAL_URL: portal,
    SAL_URL: sal,
    PLUGIN_URL: plugin,
    APPS_HOME_URL: appsHomeUrl,
  };
};

const getUrls = () => {
  const env = import.meta.env as any;
  const VITE_APP_ENV = env?.VITE_APP_ENV ?? "dev";

  const usingSecondary = ["dev2", "staging2", "prod2", "prodeu2"].some(
    (subdomain) => window.location.href.includes(`.${subdomain}.`),
  );

  const urlsByEnv: Record<string, ReturnType<typeof buildUrls>> = {
    local: buildUrls({
      vision: "http://vision.local.pingintel.com:3012/new",
      pli: "http://local.pingintel.com:3010/new/maps/pli",
      portal: "http://local.pingintel.com:3015/submit",
      sal: "http://local.pingintel.com:3010/sovfixer/activity",
      plugin:
        "https://chromewebstore.google.com/detail/pinglocation-chrome-exten/jphpdjhiclgphgjmjmjejgbchdcfjhbl",
    }),
    dev: buildUrls({
      vision: usingSecondary ? "https://vision.dev2.pingintel.com/new" : "https://vision.dev.pingintel.com/new",
      pli: usingSecondary ? "https://app.dev2.pingintel.com/new/maps/pli" : "https://app.dev.pingintel.com/new/maps/pli",
      portal: usingSecondary ?"https://vision.dev2.pingintel.com/submit" : "https://vision.dev.pingintel.com/submit",
      sal: usingSecondary ?"https://app.dev2.pingintel.com/sovfixer/activity" : "https://app.dev.pingintel.com/sovfixer/activity",
      plugin:
        "https://chromewebstore.google.com/detail/pinglocation-chrome-exten/jphpdjhiclgphgjmjmjejgbchdcfjhbl",
    }),
    stg: buildUrls({
      vision: usingSecondary ?"https://vision.staging2.pingintel.com/new" : "https://vision.staging.pingintel.com/new",
      pli: usingSecondary ?"https://app.staging2.pingintel.com/new/maps/pli" : "https://app.staging.pingintel.com/new/maps/pli",
      portal:usingSecondary ? "https://vision.staging2.pingintel.com/submit" : "https://vision.staging.pingintel.com/submit",
      sal:usingSecondary ? "https://app.staging2.pingintel.com/sovfixer/activity" : "https://app.staging.pingintel.com/sovfixer/activity",
      plugin:
        "https://chromewebstore.google.com/detail/pinglocation-chrome-exten/jphpdjhiclgphgjmjmjejgbchdcfjhbl",
    }),
    prd: buildUrls({
      vision: usingSecondary ? "https://vision.prod2.pingintel.com/new" : "https://vision.pingintel.com/new",
      pli: usingSecondary ? "https://app.prod2.pingintel.com/new/maps/pli" : "https://app.pingintel.com/new/maps/pli",
      portal: usingSecondary ? "https://vision.prod2.pingintel.com/submit" : "https://vision.pingintel.com/submit",
      sal: usingSecondary ? "https://app.prod2.pingintel.com/sovfixer/activity" : "https://app.pingintel.com/sovfixer/activity",
      plugin:
        "https://chromewebstore.google.com/detail/pinglocation-chrome-exten/jphpdjhiclgphgjmjmjejgbchdcfjhbl",
    }),
    prdeu: buildUrls({
      vision:usingSecondary ? "https://vision.eu2.pingintel.com/new" : "https://vision.eu.pingintel.com/new",
      pli:usingSecondary ? "https://app.eu2.pingintel.com/new/maps/pli" : "https://app.eu.pingintel.com/new/maps/pli",
      portal:usingSecondary ? "https://vision.eu2.pingintel.com/submit" : "https://vision.eu.pingintel.com/submit",
      sal: usingSecondary ? "https://app.eu2.pingintel.com/sovfixer/activity" : "https://app.eu.pingintel.com/sovfixer/activity",
      plugin:
        "https://chromewebstore.google.com/detail/pinglocation-chrome-exten/jphpdjhiclgphgjmjmjejgbchdcfjhbl",
    }),
  };

  return urlsByEnv[VITE_APP_ENV] ?? urlsByEnv.dev;
};

const { VISION_URL, PLI_URL, PORTAL_URL, PLUGIN_URL, SAL_URL, APPS_HOME_URL } =
  getUrls();

export { SAL_URL, VISION_URL, PLI_URL, PORTAL_URL, PLUGIN_URL, APPS_HOME_URL };
